//@ts-ignore
//@ts-ignore
import React, { useEffect, useState } from 'react';
import { useLoadModel } from 'src/hooks/useLoadModel';
import { Panorama } from '../panorama';
import { ExternalPopup } from '../popups/external-popup';
import { CustomReel, ReelCategories } from './components';
import {
  BottomBar,
  ButtonContainer,
  ButtonStyled,
  ActionsContainer,
  ButtonsContainer,
} from './styled';

export const Reel = ({
  showReelIcon,
  translation,
  showPlayIcon,
  showcaseTour,
  tour,
  tourId,
  reelCategories,
  reels,
  awsUrl,
  showcase,
  publicSweeps,
  allTags,
  fromAdmin,
  bottomBarWidth,
  panoramas,
  windowWidth,
  handleOpenVideo,
  sx,
}: any) => {
  const [reelOpen, setReelOpen] = useState(false);
  const [reelsState, setReelsState] = useState([]);

  useEffect(() => {
    setReelsState(reels);
    if (!showReelIcon) setReelOpen(false);
  }, [reels, showReelIcon]);

  const {
    loadModel,
    popUp,
    toggleExternalPopup,
    tourPlaying,
    setTourPlaying,
    panorama,
    setPanorama,
  } = useLoadModel(showcase, publicSweeps, allTags);

  const toggleTourPlaying = () => {
    setTourPlaying(!tourPlaying);
    setPanorama((prevState) => ({ ...prevState, panoramaOn: false }));
    if (tourPlaying) {
      showcaseTour.stop();
    } else showcaseTour.start();
  };

  // might need this function later
  // const markMinimap = (p: any) => {
  //   const { minimaps, selectedMinimap } = this.state;
  //   if (!minimaps || minimaps.length == 0 || selectedMinimap === null) return;
  //   minimaps[selectedMinimap].hotspots.map((h: any) => {
  //     if (h.type === 'panorama' && h.panoramaId === p.id) {
  //       this.setState({
  //         mapWalkerX: h.x,
  //         mapWalkerY: h.y,
  //         activePano: null
  //       });
  //     }
  //   });
  // };

  return (
    <>
      <BottomBar reelOpen={reelOpen} sx={sx}>
        <ActionsContainer>
          <ButtonsContainer>
            {showReelIcon && (
              <ButtonContainer
                data-balloon={translation && translation.highlightsTooltip}
                data-balloon-pos="up"
              >
                <ButtonStyled onClick={() => setReelOpen(!reelOpen)} reelOpen={reelOpen}>
                  <i className="fas fa-angle-up" />
                </ButtonStyled>
              </ButtonContainer>
            )}

            {showPlayIcon && (
              <ButtonContainer
                data-balloon={translation && translation.playTourTooltip}
                data-balloon-pos="up"
              >
                <ButtonStyled onClick={toggleTourPlaying} reelOpen={false}>
                  <i className={tourPlaying ? 'fas fa-pause-circle' : 'fas fa-play-circle'} />
                </ButtonStyled>
              </ButtonContainer>
            )}
          </ButtonsContainer>
          {reelOpen && reelCategories && (
            <ReelCategories
              reelCategories={reelCategories}
              reels={reelsState}
              setReelsState={setReelsState}
            />
          )}
        </ActionsContainer>
        <CustomReel
          reels={reelsState}
          tourId={tourId}
          awsUrl={awsUrl}
          loadModel={loadModel}
          showcaseTour={showcaseTour}
          bottomBarWidth={bottomBarWidth}
          handleOpenVideo={handleOpenVideo}
        />
      </BottomBar>

      <ExternalPopup
        show={!!popUp.externalPopupUrl && popUp.externalPopupOn}
        url={popUp.externalPopupUrl}
        onClose={() => toggleExternalPopup(popUp.externalPopupUrl)}
        width={fromAdmin ? 75 : 90}
        height={fromAdmin ? 75 : 90}
        windowWidth={windowWidth}
        {...(popUp.iframeSettings &&
          Object.keys(popUp.iframeSettings).length && { iframeSettings: popUp.iframeSettings })}
      />
      {panorama.panoramaOn && panoramas.length > 0 && tour && (
        <Panorama
          panoramas={panoramas}
          awsUrl={awsUrl}
          markMinimap={
            () => {}
            // this.markMinimap
          }
          panoPose={{ yaw: 0, pitch: 0, hfov: 0 }}
          activePano={panorama.activePano}
          transition={tour.panoramaTransition}
          // isChatGuest={room && socket && socket.connected && !host}
          defaultPanorama={tour.defaultPanorama}
          updatePanoRotation={
            () => {}
            // this.updatePanoRotation
          }
          openHotspot={
            () => {}
            // sdk.openedPanoHotspot.bind(this)
          }
          onSceneChange={
            () => {}
            // this.handlePanoSceneChange
          }
        />
      )}
    </>
  );
};
